import type { ITranslationContext } from "@op/utils";
import { useLingui } from "@lingui/react/macro";

export function useTranslations() {
  const { t } = useLingui();

  const translations: ITranslationContext = {
    metaIntro: {
      published: t`Published:`,
      notYetPublished: t`Not yet published`,
      moreInformation: t`More information`,
      openPdf: t`Open PDF`,
      copyLink: t`Copy link`,
      pageType: t`Page type`,
      olderVersions: t`Older versions`,
      doi: t`DOI`,
      cite: t`Cite`,
      contact: t`Contact`,
      copyright: t`Copyright`,
      imageCredits: t`Image credits`,
      references: t`References`,
      copyCitation: t`Copy citation`,
      copyDoi: t`Copy DOI`,
      copied: t`Copied`,
      otherLanguages: t`Other languages`,
    },
    figure: {
      expand: t`Expand`,
      viewSource: t`View source`,
    },
    citation: {
      viewSource: t`View source`,
    },
    readingCompanion: {
      outline: t`Outline`,
      citations: t`References`,
      figures: t`Figures`,
    },
    videoEmbed: {
      consent: t`This is a video embedded from YouTube, a service that may collect personal data such as your IP address, as outlined in YouTube's privacy policy. By pressing play, you consent to the collection of this data.`,
    },
    excursionCard: {
      see: t`See`,
    },
    citations: {
      citations: t`Citations`,
    },
    glossary: {
      glossary: t`Glossary`,
    },
    projectPage: {
      toTopic: t`To topic`,
    },
    legal: {
      imprint: t`Imprint`,
      privacy: t`Privacy Policy`,
    },
  };
  return translations;
}
